// Textos de la zona "studio" (Estudio de Curva, components/studio/). Claves con prefijo "studio.".
const en = {
  'studio.title': 'CURVE STUDIO',
  'studio.subtitle': 'Analyzer for musicians and engineers — look at every sound in detail',
  'studio.win.small': 'Small: tuck it into a corner',
  'studio.win.max': 'Large: almost full screen',
  'studio.win.restore': 'Back to its previous size',
  'studio.win.pip': 'Separate always-on-top window (replaces the Master floating panel if it is open)',
  'studio.win.back': 'Back into the page',
  'studio.win.close': 'Close the studio',

  'studio.speed': 'Speed',
  'studio.speed.muyLenta': 'Very slow',
  'studio.speed.lenta': 'Slow',
  'studio.speed.media': 'Medium',
  'studio.speed.rapida': 'Fast',
  'studio.res': 'Resolution',
  'studio.tilt': 'Tilt dB/oct',
  'studio.range': 'Range dB',
  'studio.layers': 'Layers',
  'studio.legend.post': 'Out',
  'studio.legend.pre': 'In',
  'studio.legend.pre.help': 'Blue line: the sound BEFORE your rack. Where gold rises above blue, your effects are adding; where it sinks, they are cutting.',
  'studio.legend.peak': 'Peak',
  'studio.legend.peak.help': 'Orange line: the highest the curve reached; it holds 2 s and then falls slowly.',
  'studio.legend.avg': 'Average',
  'studio.legend.avg.help': 'White dashed line: the average of the last ~10 s. It shows what the song IS, not what is playing this instant.',
  'studio.legend.ref': 'Ref',
  'studio.legend.ref.help': 'Violet line: your saved reference. Compare your mix against a song you like (A/B).',
  'studio.ref.take': 'Save ref',
  'studio.ref.clear': 'Clear ref',
  'studio.ref.help': 'Saves the average curve as a reference (it stays even if you reload). Play a song you like, save it, then compare yours.',
  'studio.reset': 'Reset',
  'studio.reset.help': 'Starts measuring from zero: average, peaks, integrated LUFS and clip count.',
  'studio.help': 'Gold = what comes out of your rack. Hover the curve: frequency, note, level In/Out and what your rack does there. The piano below marks the loudest note.',

  'studio.noSignal': 'No signal — start a capture to measure.',
  'studio.note': 'Note',
  'studio.key': 'Key',
  'studio.bright': 'Brightness',

  'studio.mod.button': 'Modules',
  'studio.mod.title': 'WHAT TO SHOW BELOW',
  'studio.mod.help': 'Turn modules on or off and order them with ↑ ↓. The studio remembers your choice.',
  'studio.mod.preset.musician': 'Musician',
  'studio.mod.preset.mix': 'Mix',
  'studio.mod.preset.master': 'Master',
  'studio.mod.preset.all': 'All',
  'studio.mod.preset.none': 'Curve only',
  'studio.mod.hide': 'Hide this module',
  'studio.mod.up': 'Move up',
  'studio.mod.down': 'Move down',
  'studio.mod.empty': 'Only the curve. ▦ Modules to add measurements below.',
  'studio.adv': 'Curve',
  'studio.adv.help': 'Resolution, tilt and range of the curve',

  'studio.note.title': 'Note playing',
  'studio.note.desc': 'The loudest note right now, with its tuning in cents. It only changes when the new note holds a moment.',
  'studio.note.stands': 'stands out {db} dB',
  'studio.note.none': 'No clear note (dense mix or noise)',
  'studio.key.title': 'Key',
  'studio.key.desc': 'The key of the WHOLE song: it measures the tuning, listens to every note (bass apart) and compares with three music-theory profiles. Needs ~10 s; after 3 s of silence it starts over (new song).',
  'studio.key.major': 'major',
  'studio.key.minor': 'minor',
  'studio.key.relative': 'Relative: {k}',
  'studio.key.camelot': 'Camelot wheel (DJ): neighbours ±1 mix well',
  'studio.key.conf': 'Confidence',
  'studio.key.alts': 'Also possible',
  'studio.key.now': 'This section',
  'studio.key.same': 'same as the song',
  'studio.key.tuning': 'Tuning',
  'studio.key.tuningVal': 'A4 = {hz} Hz ({c} ¢)',
  'studio.key.confHigh': 'Clear: the harmony points to a single key',
  'studio.key.confMid': 'Fairly sure: compare with the second option',
  'studio.key.confLow': 'Ambiguous harmony (modal, atonal or few notes)',
  'studio.key.listening': 'Listening… it takes a few seconds of music',

  'studio.chroma.title': 'The 12 notes',
  'studio.chroma.desc': 'How much each note sounds (every octave together, last ~2 s). Framed = notes of the detected scale.',
  'studio.chroma.top': 'Most present',

  'studio.lufs.title': 'Loudness (LUFS)',
  'studio.lufs.desc': 'How loud it SOUNDS to the ear (BS.1770), not the peak. Spotify and YouTube normalize to −14 LUFS.',
  'studio.lufs.short': 'short 3 s',
  'studio.lufs.momentary': 'Momentary (0.4 s)',
  'studio.lufs.integrated': 'Integrated (whole)',
  'studio.lufs.max': 'Max momentary',
  'studio.lufs.wait': 'Integrated: needs a little music',
  'studio.lufs.onTarget': 'Right at the streaming target (−14).',
  'studio.lufs.over': '{db} dB above −14: platforms will turn it down.',
  'studio.lufs.under': '{db} dB below −14: platforms may turn it up.',

  'studio.level.title': 'Output level',
  'studio.level.desc': 'What really leaves the speakers (after the Master). dBFS: 0 is the digital ceiling.',
  'studio.level.peak': 'Peak',
  'studio.crest': 'Crest (peak − RMS)',
  'studio.crest.wide': 'Very dynamic: lots of punch (classical, jazz, acoustic)',
  'studio.crest.natural': 'Natural: punch and body balanced',
  'studio.crest.comp': 'Compressed: dense and loud (pop, radio)',
  'studio.crest.crushed': 'Squashed: little punch left — ease off compression',
  'studio.clips': 'Hits on the ceiling',

  'studio.stereo.title': 'Stereo',
  'studio.stereo.desc': 'Correlation: +1 = mono, 0 = very wide, below 0 = phase problems (it cancels on a phone speaker).',
  'studio.corr': 'Correlation',
  'studio.corr.mono': 'Almost mono',
  'studio.corr.healthy': 'Healthy stereo',
  'studio.corr.wide': 'Very wide: check how it sounds in mono',
  'studio.corr.phase': 'Phase! In mono parts of it disappear',
  'studio.bal': 'Balance',
  'studio.bal.center': 'Centered',
  'studio.bal.left': '{db} dB to the left',
  'studio.bal.right': '{db} dB to the right',

  'studio.shape.title': 'Character',
  'studio.shape.desc': 'The "color" of the sound in three numbers.',
  'studio.tonal': 'Tonal vs noise',
  'studio.rolloff': '85 % of energy below',
  'studio.bright.dark': 'Dark: lots of low end, few highs',
  'studio.bright.warm': 'Warm',
  'studio.bright.balanced': 'Balanced',
  'studio.bright.bright': 'Bright',
  'studio.bright.very': 'Very bright: watch out for harshness',
  'studio.flat.tonal': 'Very tonal: clear notes',
  'studio.flat.mix': 'Notes and texture mixed',
  'studio.flat.noise': 'Noisy: percussion, air or distortion',

  'studio.bands.title': 'The 7 bands',
  'studio.bands.desc': 'Share of the total energy in each zone and its level in dB. The loudest one lights up. Hover a band for a tip.',
  'studio.band.sub': 'Sub',
  'studio.band.sub.hint': '20–60 Hz: felt more than heard (808, sub-bass). Too much = boom with no definition.',
  'studio.band.bass': 'Bass',
  'studio.band.bass.hint': '60–250 Hz: kick punch and the body of the bass.',
  'studio.band.lowmid': 'Low-mids',
  'studio.band.lowmid.hint': '250–500 Hz: warmth. Too much = mud, muffled sound.',
  'studio.band.mid': 'Mids',
  'studio.band.mid.hint': '500 Hz–2 kHz: body of vocals and guitars. Too much = nasal / boxy.',
  'studio.band.highmid': 'High-mids',
  'studio.band.highmid.hint': '2–4 kHz: attack and clarity. Too much = harsh, tiring.',
  'studio.band.presence': 'Presence',
  'studio.band.presence.hint': '4–6 kHz: the ear is most sensitive here; it brings the voice forward.',
  'studio.band.brilliance': 'Brilliance',
  'studio.band.brilliance.hint': '6–20 kHz: cymbals, air, sibilance (the S sounds).',

  'studio.rack.title': 'In → Out: what your rack does',
  'studio.rack.desc': 'Out minus In, per band. Blue = your effects add, red = they cut. Total = change in overall level.',
  'studio.rack.total': 'Total level',
  'studio.rack.neutral': 'Your rack keeps the tonal balance (it only changes the level, if anything).',
  'studio.rack.more': 'Biggest change: +{db} dB in {band} compared to the rest.',
  'studio.rack.less': 'Biggest change: −{db} dB in {band} compared to the rest.',

  'studio.res.title': 'Resonances',
  'studio.res.desc': 'Frequencies that stand out ALL THE TIME (4 s average): room, instrument or effect ringing. Try a narrow cut (high Q) of −2 to −4 dB there.',
  'studio.res.none': 'None: nothing sticks out persistently.',
  'studio.peaks.title': 'Peaks right now',

  'studio.hover.rack': 'rack',
  'studio.hover.vsRef': 'vs ref',
  'studio.hover.res': '▲ resonance: stands out {db} dB',

  'player.viz.studio': 'Studio',
  'player.viz.studioTitle': 'Opens the Curve Studio: a large window with the slow curve, In vs Out, notes, key, LUFS, stereo and resonances',
};

const es = {
  'studio.title': 'ESTUDIO DE CURVA',
  'studio.subtitle': 'Analizador para músicos e ingenieros — mira cada sonido a detalle',
  'studio.win.small': 'Pequeño: lo deja en una esquina',
  'studio.win.max': 'Grande: casi pantalla completa',
  'studio.win.restore': 'Vuelve a su tamaño anterior',
  'studio.win.pip': 'Ventana aparte siempre encima (reemplaza al panel flotante del Master si está abierto)',
  'studio.win.back': 'Volver dentro de la página',
  'studio.win.close': 'Cerrar el estudio',

  'studio.speed': 'Velocidad',
  'studio.speed.muyLenta': 'Muy lenta',
  'studio.speed.lenta': 'Lenta',
  'studio.speed.media': 'Media',
  'studio.speed.rapida': 'Rápida',
  'studio.res': 'Resolución',
  'studio.tilt': 'Inclinación dB/oct',
  'studio.range': 'Rango dB',
  'studio.layers': 'Capas',
  'studio.legend.post': 'Sale',
  'studio.legend.pre': 'Entra',
  'studio.legend.pre.help': 'Línea azul: el sonido ANTES de tu rack. Donde el dorado sube sobre el azul, tus efectos suman; donde baja, recortan.',
  'studio.legend.peak': 'Pico',
  'studio.legend.peak.help': 'Línea naranja: lo más alto que llegó la curva; aguanta 2 s y luego baja despacio.',
  'studio.legend.avg': 'Promedio',
  'studio.legend.avg.help': 'Línea blanca punteada: el promedio de los últimos ~10 s. Enseña lo que la canción ES, no lo que suena este instante.',
  'studio.legend.ref': 'Ref',
  'studio.legend.ref.help': 'Línea violeta: tu referencia guardada. Compara tu mezcla con una canción que te guste (A/B).',
  'studio.ref.take': 'Guardar ref',
  'studio.ref.clear': 'Borrar ref',
  'studio.ref.help': 'Guarda la curva promedio como referencia (se queda aunque recargues). Pon una canción que te guste, guárdala y compara la tuya.',
  'studio.reset': 'Reiniciar',
  'studio.reset.help': 'Empieza la medida de cero: promedio, picos, LUFS integrados y conteo de toques al techo.',
  'studio.help': 'Dorado = lo que sale de tu rack. Pasa el ratón por la curva: frecuencia, nota, nivel Entra/Sale y qué hace tu rack ahí. El piano de abajo marca la nota más fuerte.',

  'studio.noSignal': 'Sin señal — inicia una captura para medir.',
  'studio.note': 'Nota',
  'studio.key': 'Tonalidad',
  'studio.bright': 'Brillo',

  'studio.mod.button': 'Módulos',
  'studio.mod.title': 'QUÉ VER ABAJO',
  'studio.mod.help': 'Enciende o apaga módulos y ordénalos con ↑ ↓. El estudio recuerda tu elección.',
  'studio.mod.preset.musician': 'Músico',
  'studio.mod.preset.mix': 'Mezcla',
  'studio.mod.preset.master': 'Master',
  'studio.mod.preset.all': 'Todo',
  'studio.mod.preset.none': 'Solo curva',
  'studio.mod.hide': 'Ocultar este módulo',
  'studio.mod.up': 'Subir',
  'studio.mod.down': 'Bajar',
  'studio.mod.empty': 'Solo la curva. ▦ Módulos para añadir medidas abajo.',
  'studio.adv': 'Curva',
  'studio.adv.help': 'Resolución, inclinación y rango de la curva',

  'studio.note.title': 'Nota que suena',
  'studio.note.desc': 'La nota más fuerte ahora, con su afinación en cents. Solo cambia cuando la nueva aguanta un momento.',
  'studio.note.stands': 'sobresale {db} dB',
  'studio.note.none': 'Sin nota clara (mezcla densa o ruido)',
  'studio.key.title': 'Tonalidad',
  'studio.key.desc': 'La tonalidad de TODA la canción: mide la afinación, escucha cada nota (el bajo aparte) y compara con tres perfiles de teoría musical. Necesita ~10 s; tras 3 s de silencio empieza de nuevo (canción nueva).',
  'studio.key.major': 'mayor',
  'studio.key.minor': 'menor',
  'studio.key.relative': 'Relativa: {k}',
  'studio.key.camelot': 'Rueda Camelot (DJ): los vecinos ±1 mezclan bien',
  'studio.key.conf': 'Confianza',
  'studio.key.alts': 'También posible',
  'studio.key.now': 'Esta sección',
  'studio.key.same': 'igual que la canción',
  'studio.key.tuning': 'Afinación',
  'studio.key.tuningVal': 'La4 = {hz} Hz ({c} ¢)',
  'studio.key.confHigh': 'Clara: la armonía apunta a una sola tonalidad',
  'studio.key.confMid': 'Bastante segura: compara con la segunda opción',
  'studio.key.confLow': 'Armonía ambigua (modal, atonal o pocas notas)',
  'studio.key.listening': 'Escuchando… necesita unos segundos de música',

  'studio.chroma.title': 'Las 12 notas',
  'studio.chroma.desc': 'Cuánto suena cada nota (todas las octavas juntas, últimos ~2 s). Enmarcadas = notas de la escala detectada.',
  'studio.chroma.top': 'La más presente',

  'studio.lufs.title': 'Sonoridad (LUFS)',
  'studio.lufs.desc': 'Qué tan fuerte SE OYE (BS.1770), no el pico. Spotify y YouTube normalizan a −14 LUFS.',
  'studio.lufs.short': 'corto 3 s',
  'studio.lufs.momentary': 'Momentánea (0.4 s)',
  'studio.lufs.integrated': 'Integrada (todo)',
  'studio.lufs.max': 'Máx. momentánea',
  'studio.lufs.wait': 'Integrada: falta un poco de música',
  'studio.lufs.onTarget': 'Justo en el objetivo de streaming (−14).',
  'studio.lufs.over': '{db} dB sobre −14: las plataformas la bajarán.',
  'studio.lufs.under': '{db} dB bajo −14: las plataformas podrían subirla.',

  'studio.level.title': 'Nivel de salida',
  'studio.level.desc': 'Lo que de verdad sale por los parlantes (después del Master). dBFS: 0 es el techo digital.',
  'studio.level.peak': 'Pico',
  'studio.crest': 'Cresta (pico − RMS)',
  'studio.crest.wide': 'Muy dinámico: mucha pegada (clásica, jazz, acústico)',
  'studio.crest.natural': 'Natural: pegada y cuerpo equilibrados',
  'studio.crest.comp': 'Comprimido: denso y fuerte (pop, radio)',
  'studio.crest.crushed': 'Aplastado: queda poca pegada — afloja la compresión',
  'studio.clips': 'Toques al techo',

  'studio.stereo.title': 'Estéreo',
  'studio.stereo.desc': 'Correlación: +1 = mono, 0 = muy ancho, bajo 0 = problemas de fase (en el parlante de un celular se cancela).',
  'studio.corr': 'Correlación',
  'studio.corr.mono': 'Casi mono',
  'studio.corr.healthy': 'Estéreo sano',
  'studio.corr.wide': 'Muy ancho: revisa cómo suena en mono',
  'studio.corr.phase': '¡Fase! En mono parte del sonido desaparece',
  'studio.bal': 'Balance',
  'studio.bal.center': 'Centrado',
  'studio.bal.left': '{db} dB a la izquierda',
  'studio.bal.right': '{db} dB a la derecha',

  'studio.shape.title': 'Carácter',
  'studio.shape.desc': 'El "color" del sonido en tres números.',
  'studio.tonal': 'Tonal vs ruido',
  'studio.rolloff': '85 % de la energía bajo',
  'studio.bright.dark': 'Oscuro: muchos graves, pocos agudos',
  'studio.bright.warm': 'Cálido',
  'studio.bright.balanced': 'Equilibrado',
  'studio.bright.bright': 'Brillante',
  'studio.bright.very': 'Muy brillante: ojo con la dureza',
  'studio.flat.tonal': 'Muy tonal: notas claras',
  'studio.flat.mix': 'Notas y textura mezcladas',
  'studio.flat.noise': 'Ruidoso: percusión, aire o distorsión',

  'studio.bands.title': 'Las 7 bandas',
  'studio.bands.desc': 'Qué parte de la energía total hay en cada zona y su nivel en dB. Se enciende la más fuerte. Pasa el ratón por una banda para un consejo.',
  'studio.band.sub': 'Sub',
  'studio.band.sub.hint': '20–60 Hz: se siente más que se oye (808, sub-bajo). Demasiado = retumbe sin definición.',
  'studio.band.bass': 'Graves',
  'studio.band.bass.hint': '60–250 Hz: pegada del bombo y cuerpo del bajo.',
  'studio.band.lowmid': 'Medios-graves',
  'studio.band.lowmid.hint': '250–500 Hz: calidez. Demasiado = barro, sonido apagado.',
  'studio.band.mid': 'Medios',
  'studio.band.mid.hint': '500 Hz–2 kHz: cuerpo de voces y guitarras. Demasiado = nasal / a caja.',
  'studio.band.highmid': 'Medios-agudos',
  'studio.band.highmid.hint': '2–4 kHz: ataque y claridad. Demasiado = duro, cansa.',
  'studio.band.presence': 'Presencia',
  'studio.band.presence.hint': '4–6 kHz: aquí el oído es más sensible; adelanta la voz.',
  'studio.band.brilliance': 'Brillo',
  'studio.band.brilliance.hint': '6–20 kHz: platillos, aire, sibilancia (las S).',

  'studio.rack.title': 'Entra → Sale: qué hace tu rack',
  'studio.rack.desc': 'Sale menos Entra, por banda. Azul = tus efectos suman, rojo = recortan. Total = cambio de nivel general.',
  'studio.rack.total': 'Nivel total',
  'studio.rack.neutral': 'Tu rack mantiene el balance tonal (si acaso, solo cambia el nivel).',
  'studio.rack.more': 'Mayor cambio: +{db} dB en {band} respecto al resto.',
  'studio.rack.less': 'Mayor cambio: −{db} dB en {band} respecto al resto.',

  'studio.res.title': 'Resonancias',
  'studio.res.desc': 'Frecuencias que sobresalen TODO EL RATO (promedio de 4 s): sala, instrumento o un efecto que pita. Prueba ahí un corte estrecho (Q alto) de −2 a −4 dB.',
  'studio.res.none': 'Ninguna: nada sobresale de forma constante.',
  'studio.peaks.title': 'Picos ahora',

  'studio.hover.rack': 'rack',
  'studio.hover.vsRef': 'vs ref',
  'studio.hover.res': '▲ resonancia: sobresale {db} dB',

  'player.viz.studio': 'Estudio',
  'player.viz.studioTitle': 'Abre el Estudio de Curva: una ventana grande con la curva lenta, Entra vs Sale, notas, tonalidad, LUFS, estéreo y resonancias',
};

const studio = { en, es };
export default studio;
